/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-26 17:55:16
 * @LastEditTime: 2019-03-11 14:15:56
 */
const signin = () => import("@/views/login/signin"),
    demo = () => import("@/views/home/demo"),
    home = () => import("@/views/home/index"),
    Product = () => import("@/views/modular/Product"),
    proddetails = () => import("@/views/modular/prodDetails"),
    helpsupport = () => import("@/views/modular/helpSupport"),
    productduction = () => import("@/views/modular/productDuction"),
    serve = () => import("@/views/service/serve"),
    introduction = () => import("@/views/summary/introduction"),
    journalism = () => import("@/views/aboutAs/Journalism"),
    Public = () => import("@/views/contact/Public"),
    contactus = () => import("@/views/contact/contactus"),
    merchants = () => import("@/views/merchants/merchants"),
    rivacypolicy = () => import("@/views/summary/rivacypolicy"),
    logisticsAgreement = () => import("@/views/summary/logisticsAgreement"),
    serviceAgreement = () =>  import("@/views/summary/serviceAgreement"),
    collectindividual = () => import("@/views/summary/collectindividual"),
    collectPermission = () => import("@/views/summary/collectPermission"),
    corporation = () => import("@/views/summary/corporation"),
    thirdpart = () => import("@/views/summary/thirdpart"),
    questionquery = () => import("@/views/helpcenter/questionquery"),
    anenstAs = () => import("@/views/aboutAs/anenstAs"),
    demoModel = () => import("@/views/outmodel/demoModel");
// 默认路由
const baseRoute = [
    {
        path: "/",
        name: "home",
        component: home
    },

    {
        path: "/signin",
        name: "signin",
        component: signin
    },
    // {
    //     path: "/home",
    //     name: "home",
    //     component: home
    // },
    {
        path: "/productduction",
        name: "productduction",
        component: productduction,
        children: [
            {
                path: "/Product/:id",
                name: "Product",
                component: Product
            },
            {
                path: "/proddetails/:id",
                name: "proddetails",
                component: proddetails
            },
            {
                path: "/serve/:id",
                name: "serve",
                component: serve
            },
            {
                path: "/demoModel",
                name: "demoModel",
                component: demoModel
            }
        ]
    },
    {
        path: "/Public",
        name: "Public",
        component: Public,
        children: [
            {
                path: "/introduction/:id",
                name: "introduction",
                component: introduction
            },
            {
                path: "/rivacypolicy",
                name: "rivacypolicy",
                component: rivacypolicy
            },
            {
                path: "/serviceAgreement",
                name: "serviceAgreement",
                component: serviceAgreement
            },
            {
                path: "/logisticsAgreement",
                name: "logisticsAgreement",
                component: logisticsAgreement
            },
            {
                path: "/collectindividual",
                name: "collectindividual",
                component: collectindividual
            },
            {
                path: "/collectPermission",
                name: "collectPermission",
                component: collectPermission
            },
            {
                path: "/corporation",
                name: "corporation",
                component: corporation
            },
            {
                path: "/thirdpart",
                name: "thirdpart",
                component: thirdpart
            },
            {
                path: "/anenstAs/:id",
                name: "anenstAs",
                component: anenstAs
            },
            {
                path: "/journalism",
                name: "journalism",
                component: journalism
            },
            {
                path: "/questionquery",
                name: "questionquery",
                component: questionquery
            },
            {
                path: "/contactus",
                name: "contactus",
                component: contactus
            }
        ]
    },
    {
        path: "/helpsupport/:id",
        name: "helpsupport",
        component: helpsupport
    },
    {
        path: "/merchants/:id",
        name: "merchants",
        component: merchants
    },
    { path: "*", redirect: "/", hidden: true }
];
export default baseRoute;
